import React from 'react';
import UserForm from './UserForm';
import AuthWizardProvider from './AuthWizardProvider';
import AuthShell from '../AuthShell';

const WizardLayout = () => (
  <AuthShell wide>
    <AuthWizardProvider>
      <UserForm />
    </AuthWizardProvider>
  </AuthShell>
);

export default WizardLayout;
